export const RU_PHONE_DIGITS = 11;

/** После кода 7 — типичная нумерация зоны +7 (РФ/KZ и др.); отсекает мусор вроде +7 222 222-22-22 → 72222222222. */
export const RU_ZONE_PHONE_PLAUSIBLE = /^7[34789]\d{9}$/;

export function normalizePhoneRu(raw: string): string {
  const digits = (raw || '').replace(/\D/g, '');
  if (!digits) return '';
  let normalized = digits;
  if (normalized.startsWith('8') && normalized.length >= RU_PHONE_DIGITS) {
    normalized = `7${normalized.slice(1)}`;
  } else if (!normalized.startsWith('7')) {
    normalized = `7${normalized}`;
  }
  return normalized.slice(0, RU_PHONE_DIGITS);
}

export function formatPhoneInputRu(raw: string): string {
  const digits = normalizePhoneRu(raw);
  if (!digits) {
    return '+7 ';
  }
  const local = digits.slice(1);
  const p1 = local.slice(0, 3);
  const p2 = local.slice(3, 6);
  const p3 = local.slice(6, 8);
  const p4 = local.slice(8, 10);
  let formatted = '+7';
  if (p1) formatted += ` ${p1}`;
  if (p2) formatted += ` ${p2}`;
  if (p3) formatted += `-${p3}`;
  if (p4) formatted += `-${p4}`;
  return formatted;
}

export { validatePhoneRu } from './validation';
